(function () {
  angular.module('leanlaw').controller('BillingReviewCtrl', BillingReviewSummaryCtrl);
  BillingReviewSummaryCtrl.$inject = ['$scope', '$rootScope', '$state', 'userService', 'reviewService', 'alerts', 'ModalService'];
  function BillingReviewSummaryCtrl($scope, $rootScope, $state, userService, reviewService, alerts, ModalService) {
    alerts.dismiss();
    $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
      // dismiss alerts when changing from one tab to the other
      // (but not when returning to tab from viewing an invoice)
      if (tabState(toState) && tabState(fromState)) {
        alerts.dismiss();
      }
    });
    function tabState(state) {
      return state.name === "billing.invoice.summary" || state.name === "billing.invoice" || /^billing.review.\w+$/.test(state.name);
    }
    $scope.state = $state;
    $scope.listCallback = {};
    $scope.stages = reviewService.stages;
    $scope.options = reviewService.options;
    $scope.isStage = function (stage) {
      const [,, currentStage] = $state.current.name.split('.');
      return currentStage === stage;
    };
    $scope.showingInvoice = function () {
      return $state.current.name.indexOf('.view') > 0 || $state.current.name.indexOf('.edit') > 0;
    };
    $scope.reload = function (params) {
      $scope.listCallback.reload(params);
    };
  }
})();